import { xenvActionFactory, xenv } from '../xenv';
import { /* alimpCalendar, */ wxmpCalendar, passengerCalendar, passengerCanUseCalendar } from '../platform/xenv';
const xenvCalendarConfig = {
    'wxmp': wxmpCalendar,
    'passenger': passengerCalendar,
};
export const formateCalendarOpt = (option) => {
    const { startTime, endTime, alarmOffset, repeatEndTime, ...rst } = option;
    let currentOpt = {};
    switch (xenv()) {
        case 'passenger':
            currentOpt = {
                title: option?.title,
                content: option?.description,
                startDate: startTime,
                endDate: endTime,
                reminderOffset: alarmOffset,
                repeatInterval: option?.repeatInterval,
                repeatEndTime,
                extParams: option?.extParams
            };
            break;
        case 'wxmp':
            currentOpt = {
                startTime,
                endTime,
                repeatEndTime,
                alarmOffset: alarmOffset ? alarmOffset * 60 : 0,
                ...rst,
            };
            break;
        default:
            currentOpt = option;
            break;
    }
    return currentOpt;
};
export const addCalendar = (option) => {
    const calendarConfig = formateCalendarOpt(option);
    const fn = xenvActionFactory('addCalendar', xenvCalendarConfig);
    return fn(calendarConfig);
};
export const isCanUseCalendar = async (option = { ios: '6.7.18', android: '6.8.2', harmonyos: '6.8.2' }) => {
    if (xenv() === 'passenger') {
        return passengerCanUseCalendar(option);
    }
    return Promise.resolve(xenv() === 'wxmp');
};
